/**
 * Бекенд недоступен (сеть отвалилась, сервер не отвечает, шлюз вернул 502/504).
 * Такие ошибки не показываются тостами — состояние связи показывает ConnectivityService.
 */
export class NetworkUnavailableError {}
